{
  "title": "Conectar mi aplicación móvil",
  "form": {
    "mobileApp": {
      "label": "Seleccione la aplicación que desee para generar el código QR",
      "placeholder": "Seleccione una aplicación",
      "validation": {
        "required": "Debe seleccionar una aplicación móvil"
      }
    },
    "button": {
      "content": "Generar el código QR"
    }
  },
  "qrCode": {
    "expirationDate": "Caduca el"
  },
  "downloadOfflineAccess": {
    "button": "Descargar mi configuración sin conexión"
  },
  "passwordModal": {
    "password": {
      "validation": {
        "pattern": "La contraseña debe contener al menos 12 caracteres, entre los que se deben incluir mayúsculas y minúsculas, números y caracteres especiales",
        "required": "Debe introducir una contraseña"
      },
      "label": "Contraseña"
    },
    "title": "Introduzca la contraseña proporcionada por la aplicación My LogUp"
  }
}
